export const onDialogExited = dialogType => ({
  widget: 'tokens',
  type: 'onDialogExited',
  payload: { dialogType },
})



// WEBPACK FOOTER //
// ./src/tokens/actions/onDialogExited.js